import Call from "@mui/icons-material/Call";
import { Grid, Typography } from "@mui/material";
import { Link } from "./Link";
import { useBrandingContext } from "@/contexts/BrandingContext";

export const Help: React.FC = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={1} style={{ alignSelf: "center", textAlign: "center" }}>
        <CallIcon />
      </Grid>
      <Grid item xs={11}>
        <ContactUsInfo />
      </Grid>
    </Grid>
  );
};

export const CallIcon: React.FC = () => {
  const brand = useBrandingContext();
  return (
    <a href={brand.contactUsUrl} target="_blank" rel="noopener noreferrer">
      <Call />
    </a>
  );
};

export const ContactUsInfo: React.FC = () => {
  const brand = useBrandingContext();

  return (
    <Typography>
      <Link variant="text" target="_blank" to={brand.contactUsUrl}>
        Contact Us
      </Link>
    </Typography>
  );
};
